const strings = {
  seat: '椅座',
  chair_leg: '椅腳',
  center_chair_leg: '複合式椅腳',
  back_rest: '椅背',
  back_support: '椅背支撐',
  arm_rest: '扶手',
  table_top: '桌面',
  chair_leg_front_left: '左前腳',
  chair_leg_front_right: '右前腳',
  chair_leg_rear_right: '右後腳',
  chair_leg_rear_left: '左後腳',
  arm_rest_left: '左扶手',
  arm_rest_right: '右扶手',
  combination: '複合式零件',
  remove_back_support_warning:
    '移除「椅背支撐」將會取消原本選擇的「椅背」，您確定要移除嗎？',
  use_combination_chair_leg_warning:
    '使用「複合式椅腳」將會取消原本選擇的「椅腳」，您確定要使用嗎？',
  use_combination_seat_warning:
    '使用「複合式椅座」將會取消原本選擇的「椅背」和「椅背支撐」，您確定要使用嗎？'
};

export default {
  get: function get(id) {
    return strings[id] || id;
  }
};



// WEBPACK FOOTER //
// ./src/services/l10n-service.js